import Audio from '~/Audio';
import { logError } from '~/logger';
import messages, { GameStateStoreMessage } from '~/flux/stores/GameStateStore/messages';
import mutationPlaceItemInHeroInventory from '~/graphql/game-items/mutationPlaceItemInHeroInventory';

export default async function placeItemInHeroInventory(
  {
    playerId,
    setInventoryAndHeroRoster,
    emit,
  }: {
    playerId: string;
    setInventoryAndHeroRoster: (data: { inventory?: unknown; hero_roster?: unknown }) => void;
    emit: (event: GameStateStoreMessage) => void;
  },
  action: { game_item: { uid: string }; from: any; to: any }
) {
  try {
    const data = await mutationPlaceItemInHeroInventory({
      playerId,
      itemId: action.game_item.uid,
      from: {
        location: action.from.location,
        heroHandle: action.from.hero_handle,
        bagSlotIndex: action.from.bag_slot_index,
        bagIndex: action.from.bag_index,
        bagItemIndex: action.from.bag_item_index,
      },
      to: {
        location: action.to.location,
        heroHandle: action.to.hero_handle,
        bagSlotIndex: action.to.bag_slot_index,
        bagIndex: action.to.bag_index,
        bagItemIndex: action.to.bag_item_index,
      },
    });

    console.log('placeItemInHeroInventory response:', {
      hasInventory: data.inventory != null,
      hasHeroRoster: data.heroRoster != null,
    });

    setInventoryAndHeroRoster({
      ...(data.inventory != null && { inventory: data.inventory }),
      ...(data.heroRoster != null && { hero_roster: data.heroRoster }),
    });

    console.log('Emitting EQUIPMENT_CHANGE event');
    emit(messages.EQUIPMENT_CHANGE);
    Audio.play('equipment_storage');
  } catch (err) {
    logError(err, {
      module: 'GameStateStore',
      func: 'placeItemInHeroInventory',
      playerId,
      action: JSON.stringify(action),
    });
  }
}
